import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { CompanyTemplate } from './types';
import { ContentTemplateCompany } from 'src/features/templates/templates.types';

const companyTemplateApiPath = `/companies/templates`;

export const getTemplates = async (
  data: Partial<CompanyTemplate>
): Promise<AxiosResponse<CompanyTemplate & ApiError>> => {
  return instance
    .post<CompanyTemplate>(companyTemplateApiPath, data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const templateApiPath = (id: string) => `/content/templates/${id}`;
const templateCompaniesApiPath = (id: string) => `${templateApiPath(id)}/companies`;

export const addTemplateCompany = async ({
  templateId,
  data,
}: {
  templateId: string;
  data: { companyId: string };
}): Promise<AxiosResponse<ContentTemplateCompany & ApiError>> => {
  return instance
    .post<ContentTemplateCompany>(templateCompaniesApiPath(templateId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};
